require('../../../node_modules/bootstrap/dist/css/bootstrap.min.css');
var $ = require('jquery')
import AppHeader from '../AppHeader'
import AppFooter from '../AppFooter'

export default {
  name: 'app',
  created: function() {
    if (this.$store.getters.isSSL && location.protocol === 'http:') {
      location.replace(location.href.replace(/http:/, 'https:'))
    }

    this.healthcheck()
    if (!this.$store.getters.isLogin && window.localStorage.getItem('access_token')) {
      this.authorize()
    }
    // 画面タップ時にbootstrapのトグルメニューを閉じる
    if (window.innerWidth <= 769) {
      document.body.onclick = function() {
        $(".navbar-collapse").collapse('hide');
      }
    }
  },
  computed: {
    maintenance () {
      return this.$store.getters.maintenance
    }
  },
  components: {
    AppHeader,
    AppFooter
  },
  methods: {
    authorize: function() {
      this.$store.dispatch('AUTHORIZE')
    },
    healthcheck: function() {
      this.$store.dispatch('HEALTHCHECK')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/app.js